import { useTranslation } from "../../plugins/i18next/ea-react-i18next"
import Layout from "../../components/App/Layout"
import SEO from "../../components/App/SEO"
import ProductBanner from '../../components/Products/ProductBanner'
import { graphql } from 'gatsby'
import { ProductType } from "../../components/Products/ProductList"
import TipsterExcitement from "../../components/Products/Tipster/TipsterExcitement"
import TipsterDetails from "../../components/Products/Tipster/TipsterDetails"
import TipsterSignIn from "../../components/Products/Tipster/TipsterSignIn"
import TipsterCompanyLeague from "../../components/Products/Tipster/TipsterCompanyLeague"
import TipsterBets from "../../components/Products/Tipster/TipsterBets"
import TipsterRankings from "../../components/Products/Tipster/TipsterRankings"
import TipsterPlayNow from "../../components/Products/Tipster/TipsterPlayNow"

export const Head = () => {
  return <SEO title='products.tipster.title' description='products.tipster.description' />;
};

const EasyMeet365 = () => {
  const { t } = useTranslation("pages", { keyPrefix: 'products.tipster' });
  return (
    <Layout>
      <ProductBanner product={ProductType.Tipster} />
      <TipsterExcitement />
      <TipsterDetails />
      <TipsterSignIn/>
      <TipsterCompanyLeague/>
      <TipsterBets/>
      <TipsterRankings/>
      <TipsterPlayNow />
    </Layout>)

}

export default EasyMeet365;

export const query = graphql`
query ($language: String) {
  locales: allLocale(filter: {language: {eq: $language}, ns: {in: ["components","pages"]}}) {
    edges {
      node {
        ns
        language
        data
      }
    }
  }
}
`;